import { useState } from "react";
import { motion } from "framer-motion";
import { media } from "@/lib/api";

export const Photo = ({ src, alt = "From the family archive", ratio = "16/10", develop = true, era, caption, onClick, className = "", testid, kenburns = true }) => {
  const [loaded, setLoaded] = useState(false);
  const old = era === "silent" || era === "sepia";
  const base = era === "silent" ? "grayscale(1) contrast(1.15)" : era === "sepia" ? "sepia(.8) contrast(1.05)" : era === "faded" ? "sepia(.3) saturate(.7)" : "none";
  return (
    <figure className={`group ${className}`} data-testid={testid}>
      <motion.div
        className="photo-frame bg-[#163B29] cursor-pointer"
        style={{ aspectRatio: ratio }}
        initial={develop ? { filter: "grayscale(1) brightness(.6)" } : false}
        whileInView={{ filter: old ? "grayscale(0) brightness(1)" : "grayscale(0) brightness(1)" }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        onClick={onClick}
      >
        {src && (
          <img
            src={media(src)}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`w-full h-full object-cover ${kenburns ? "kenburns" : ""} ${loaded ? "opacity-100" : "opacity-0"} transition-opacity duration-700 group-hover:[filter:none]`}
            style={{ filter: base }}
          />
        )}
        <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_80px_rgba(0,0,0,.45)]" />
      </motion.div>
      {caption && <figcaption className="mt-3 text-xs tracking-wide text-[#F6EFE0]/70 font-mono-x">{caption}</figcaption>}
    </figure>
  );
};
